import React from 'react';
import style from '../../style/project.module.css';
import netup from '../../assets/netup.png';
import groceryFinder from '../../assets/grocery-finder.png';
import operatingSystem from '../../assets/operatingSystem.png';

const projects = [
  {
    name: "Grocery Finder",
    description: "A web app used to search for grocery items. Leveraging API build using scraped data",
    tools: "React, Node/Express, MongoDB, Puppeteer, Docker",
    image: groceryFinder,
    projectType: "personal project",
    demoLink: "https://github.com/lilyyanglt/grocery-search-engine",
    githubLink: "https://github.com/lilyyanglt/grocery-search-engine"
  },  
  {
    name: "My Operating System",
    description: "My attempt at building an operating system from scratch initially by following a book and as I learn more concepts, I will add to the code base",
    tools: "Assembly, C, Bochs",
    image: operatingSystem,
    projectType: "personal project",
    demoLink: "https://github.com/lilyyanglt/MyOperatingSystem",
    githubLink: "https://github.com/lilyyanglt/MyOperatingSystem"
  }, 
  {
    name: "Netup",
    description: "A social platform built during Covid-19 to bridge the gap of social distancing. My role in this project was mostly backend. Handling authentication, server-side set-up, and email verification flow",
    tools: "EJS, Node/Express, MongoDB",
    image: netup,
    projectType: "group project",
    demoLink: "https://dtc10-netup.herokuapp.com/",
    githubLink: "https://github.com/lilyyanglt/COMP-2800-Team-DTC-10-Netup"
  },
  {
    name: "Mini Projects",
    description: "Smaller projects built using Codepen to explore different technologies or practice new concepts that I've learned.",
    tools: "Javascript, HTML5, CSS3, React...",
    image: "https://storage.googleapis.com/chydlx/codepen/blog-cards/image-1.jpg",
    projectType: "personal project",
    demoLink: "https://codepen.io/lilyo21o",
    githubLink: "https://codepen.io/lilyo21o"
  }, 

]

export default function Projects() {
  return (
    <div id="Projects" className={style.project}>
      <h3>Projects</h3>
      <div className={style.projectCardContainer}>
      {projects.map((project, index) => <Card key={index} content={project}/>)}
      </div>
    </div>
  )
}

/**
 * 
 * Source: card design style inspired by https://codepen.io/ChynoDeluxe/pen/bdXeqQ
 */

function Card({content}) {
  return (
    <div className={style.blogCard}>
      <div className={style.meta}>
        <div className={style.blogPhoto} style={{backgroundImage: `url(${content.image})`}}></div>
        <div className={style.details}>
          <p>{content.projectType}</p>
          <a className={style.githubBtn} href={content.githubLink}>View in Github</a>
        </div>
      </div>
      
      <div className={style.description}>
        <h1>{content.name}</h1>
        <h2>{content.tools}</h2>
        <p>{content.description}</p>
        <p className={style.goToDemo}><a href={content.demoLink}>Go to Demo</a></p>
      </div>
    </div>
  )
}